function detectTouchscreen() {
	let result = false;
	if (window.PointerEvent && "maxTouchPoints" in navigator) {
		if (navigator.maxTouchPoints > 0) {
			result = true;
		}
	} else {
		if (window.matchMedia?.("(any-pointer:coarse)").matches) {
			result = true;
		} else if (window.TouchEvent || "ontouchstart" in window) {
			result = true;
		}
	}
	return result;
}

export default detectTouchscreen;

export const isTouchScreen =
	(navigator.maxTouchPoints && navigator.maxTouchPoints > 0) ||
	window.matchMedia("(pointer: coarse)").matches;
